<link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500&amp;display=swap" as="style" rel="stylesheet">

<img class="dialogClose" src="../../assets/icons/fi_close.svg" alt="Close" (click)="closeDialog()">
<div class='mw-100p w-400 t-c m-l-a m-r-a t-l bgf9'>
    <!-- <div class="close-img">
    <img class="dialogClose" src="https://songdewnetwork.com/sgmedia/assets/images/cross-icon.png" alt="Close"
        (click)="closeDialog()">
    </div> -->
    <ul class="nav nav-tabs bg-lightgrey nav-justified  ">



        <li class='nav-item ' [class.t-c]="global.isMobile()">
            <a class="b-r-0 pointer nav-link active"
                [class.defaultCursor]="!(data.type == 'song' || data.type == 'album' || data.type == 'playlist' || data.type == 'video')"
                href='#share' data-toggle="tab"
                (click)="global.trackEvent('Share', 'Share-CTA', type + ' - ' + shareUrl)">
                {{data.type=='song-review-card'||data.type== 'album-review-card'? 'Share Review ':'Share'}}</a>
        </li>
        <li class='nav-item' [class.t-c]="global.isMobile()"
            *ngIf="data.type == 'song' || data.type == 'album' || data.type == 'playlist' || data.type == 'video'">
            <a class="b-r-0 pointer nav-link" href='#embed' data-toggle="tab"
                (click)="global.trackEvent('Share', 'Embed-CTA', type + ' - ' + shareUrl)">Embed</a>
        </li>
    </ul>

    <div class='tab-content p-25 p-t-30'>
        <div id="share" class='tab-pane active'>
            <ng-container *ngIf="data.type == 'song-review-card' || data.type == 'album-review-card'">
                <div style="width: 1px; height: 1px; display: inline-block; overflow: hidden;">
                    <div *ngIf="data.type == 'song-review-card' || data.type == 'album-review-card'"
                        style="width: 540px; height: 540px;">
                        <div class="border p-20 relative overflow-hidden f14" style="
                            width: 158px;
                            height: 158px;
                            border-radius:8px;
                            overflow: hidden;
                            font-family: Roboto;
                            background: #fff;
                            transform: scale(1.5);
                            transform-origin: top left;">
                            <img class="absolute r-0 t-0 flex-fe-c m-5-i" src="assets/images/songdew-online.png"
                                style="width: 80px;">

                            <div class="flex-fs-c blue m-t-20 f12">
                                <img *ngFor="let start of global.createRange(data.customData.stars); let i=index;"
                                    src="assets/images/cards/star.png" class="w-20" [class.m-l-5]="i>0">
                            </div>

                            <div class="strong m-t-10 f16 instaComment relative z-10">{{data.customData.comment}}</div>


                            <div class="flex-fs-c m-t-20">
                                <img [src]=" imgCdn + data.customData.commentUserDp" class="w-h-30 circular bg-black"
                                    style="overflow: hidden;">
                                <div class="m-l-10">
                                    <div class="f14">{{data.customData.commentUser}}</div>
                                    <div class="text-muted f12">{{data.customData.commentTime}}</div>
                                </div>
                            </div>

                            <div class="relative"
                                style="width: 100%; height: 1px; background: #7f7f7f; margin: 20px 0;">
                                <img src="assets/images/cards/big-star.png" style="
                                    width: 124px;
                                    position: absolute;
                                    top: -112px;
                                    right: -20px;">
                            </div>

                            <div class="flex-fs-fs" style="
                                display: flex;
                                align-items: flex-start;
                                justify-content: flex-start;
                                width: calc(100% - 45px);">
                                <div class="w-130 relative p-5 bg-white border" style="width: 130px;">
                                    <div class="absolute w-full h-full bg-grey" style="right: -5px; bottom: -5px;">
                                    </div>
                                    <div class="absolute t-0 r-0 b-0 l-0 bg-white"></div>
                                    <img class="relative w-full" [src]="imgCdn + data.customData.albumArt+'?w=500'">
                                </div>

                                <div class="p-l-20 m-t-5" style="width: calc(100% - 130px);">
                                    <div class="strong f16">{{data.customData.title}}</div>
                                    <div class="m-t-5">by {{data.customData.artistName}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 1px; height: 1px; display: inline-block; overflow: hidden;">
                    <div *ngIf="data.type == 'song-review-card' || data.type == 'album-review-card'" id="fb_card"
                        style="width: 1370px; height: 720px;">
                        <div class="border p-20 relative overflow-hidden f14" style="
                            width: 685px;
                            height: 360px;
                            overflow: hidden;
                            font-family: Roboto;
                            background: #fff;
                            transform: scale(2);
                            transform-origin: top left;">
                            <img class="absolute r-0 t-0 flex-fe-c m-5-i" src="assets/images/songdew-online.png"
                                style="width: 80px;">

                            <div class="flex-fs-c blue m-t-20 f12">
                                <img *ngFor="let start of global.createRange(data.customData.stars); let i=index;"
                                    src="assets/images/cards/star.png" class="w-20" [class.m-l-5]="i>0">
                            </div>

                            <div class="strong m-t-10 f16 instaComment relative z-10">{{data.customData.comment}}</div>


                            <div class="flex-fs-c m-t-20">
                                <img [src]="imgCdn + data.customData.commentUserDp" class="w-h-30 circular bg-black"
                                    style="overflow: hidden;">
                                <div class="m-l-10">
                                    <div class="f14">{{data.customData.commentUser}}</div>
                                    <div class="text-muted f12">{{data.customData.commentTime}}</div>
                                </div>
                            </div>

                            <div class="relative"
                                style="width: 100%; height: 1px; background: #7f7f7f; margin: 20px 0;">
                                <img src="assets/images/cards/big-star.png" style="
                                    width: 204px;
                                    position: absolute;
                                    top: -140px;
                                    right: -20px;">
                            </div>

                            <div class="flex-fs-fs" style="
                                display: flex;
                                align-items: flex-start;
                                justify-content: flex-start;
                                width: calc(100% - 125px);">
                                <div class="w-130 relative p-5 bg-white border" style="width: 130px;">
                                    <div class="absolute w-full h-full bg-grey" style="right: -5px; bottom: -5px;">
                                    </div>
                                    <div class="absolute t-0 r-0 b-0 l-0 bg-white"></div>
                                    <img class="relative w-full" [src]="imgCdn + data.customData.albumArt+'?w=500'">
                                </div>

                                <div class="p-l-20 m-t-5" style="width: calc(100% - 130px);">
                                    <div class="strong f16">{{data.customData.title}}</div>
                                    <div class="m-t-5">by {{data.customData.artistName}}</div>

                                    <div class='flex-fs-c m-t-20'>
                                        <img src="assets/images/cards/listen-it-now.png" class="w-100">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="border p-20 relative overflow-hidden f14" id="insta_card" style="
                    width: 360px;
                    height: 360px;
                    overflow: hidden;
                    transform: scale(1);
                    font-family: Roboto;
                    border-radius:8px;
                    background: #fff;">
                    <img class="absolute r-0 t-0 flex-fe-c m-5-i" src="assets/images/songdew-online.png"
                        style="width: 80px;">

                    <div class="flex-fs-c blue m-t-20 f12">
                        <img *ngFor="let start of global.createRange(data.customData.stars); let i=index;"
                            src="assets/images/cards/star.png" class="w-20" [class.m-l-5]="i>0">
                    </div>

                    <div class="strong m-t-10 f16 instaComment relative z-10">{{data.customData.comment}}</div>


                    <div class="flex-fs-c m-t-20">
                        <img [src]="imgCdn + data.customData.commentUserDp" class="w-h-30 circular bg-black"
                            style="overflow: hidden;">
                        <div class="m-l-10">
                            <div class="f14">{{data.customData.commentUser}}</div>
                            <div class="text-muted f12">{{data.customData.commentTime}}</div>
                        </div>
                    </div>

                    <div class="relative" style="width: 100%; height: 1px; background: #7f7f7f; margin: 20px 0;">
                        <img src="assets/images/cards/big-star.png" style="
                            width: 124px;
                            position: absolute;
                            top: -112px;
                            right: -20px;">
                    </div>

                    <div class="flex-fs-fs" style="
                        display: flex;
                        align-items: flex-start;
                        justify-content: flex-start;
                        width: calc(100% - 45px);">
                        <div class="w-130 relative p-5 bg-white border" style="width: 130px;">
                            <div class="absolute w-full h-full bg-grey" style="right: -5px; bottom: -5px;"></div>
                            <div class="absolute t-0 r-0 b-0 l-0 bg-white"></div>
                            <img class="relative w-full" [src]="imgCdn+data.customData.albumArt+'?w=500'">
                        </div>

                        <div class="p-l-20 m-t-5" style="width: calc(100% - 130px);">
                            <div class="strong f16">{{data.customData.title}}</div>
                            <div class="m-t-5">by {{data.customData.artistName}}</div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <img *ngIf="data.type != 'song-review-card' && data.type != 'album-review-card' && imageToShow!=null"
                class='block w-150 m-r-a m-l-a' [lazyLoad]="imageToShow">



            <!--------------Abhay Dynamic Data Code Starts from here -------->

            <div *ngIf="data.type != 'song-review-card' && data.type != 'album-review-card'" class="introflex">
                <!-- <div class="introimg">
        <img [lazyLoad]="album?.image"
            defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-album-art.png"
            [alt]="mainArtist?.name">
    </div> -->
                <div class="introcontent">
                    <div id="albumhead" style="text-transform:uppercase;color: #989AA3;">{{(this.type == 'song' ||
                        this.type == '')?
                        "Single": type}}</div>
                    <div id="albumtitle" style="display:flex;align-items:center;justify-content: center;">
                        <div class="artist-title">
                            <div class="artist-title-sub "
                                style="display:flex;align-items:center;justify-content: center;">
                                <span class="title">
                                    {{album?.title}}
                                </span>
                                <span class="fright">

                                    <a (click)="global.trackEvent((type=='')?'track-detail':type+'-detail', 'Share'); dialog.openShareDialog( (type=='') ? 'song' : type, album?.slug, album?.title, mainArtist?.name, album?.image )"
                                        title="Share">
                                        <img class="shareicon" id="albumshare" style="cursor:pointer">
                                    </a>



                                </span>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="type=='playlist'; else album_artist">
                        <div class="pldesc">
                            {{album?.description}}
                        </div>
                    </ng-container>
                    <ng-template #album_artist>
                        <div id="albumauth" style="display:flex;align-items:center">
                            <div style="flex:100%">
                                <ng-container *ngIf="album?.isVariousArtists; else singleartist">
                                    <span class="dropdown_menu pointer">
                                        <span class="dropimg">Several Artist <i class="fa fa-angle-down"
                                                aria-hidden="true" style="margin-left:8px;margin-right:8px;"></i></span>
                                        <div class="dropdown_container artistDrop">
                                            <ng-container *ngFor="let sartist of multiArt; let i=index">
                                                <div class="pb-1">
                                                    <span style="cursor:pointer;"
                                                        routerLink="/{{sartist.username}}">{{sartist.name}}</span>
                                                    <img src="../../../assets/images/albumdetails/dot.png"
                                                        style="margin-left:8px;margin-right:8px;">
                                                    <span style="font-weight:500;color:rgba(34,34,34,0.8)"
                                                        style="cursor:pointer">
                                                        <sd-follow
                                                            [data]="{'from':'song-detail','slug':sartist.username,'isFollowing':sartist.following,'version':2 }">
                                                        </sd-follow>
                                                    </span>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </span>
                                </ng-container>
                                <ng-template #singleartist>
                                    <span class="artist-name" style="cursor:pointer;"
                                        routerLink="/{{mainArtist?.slug}}">
                                        {{mainArtist?.name}}

                                    </span>


                                </ng-template>
                                <ng-container *ngIf="type!=='playlist'">
                                    <span class="tohide">
                                        <!-- <img src="../../../assets/images/..svg"
                                            style="margin-bottom:4px;margin-left:9px;margin-right:9px;"> -->
                                        <!-- {{album?.isSingleartist}} -->
                                        <span style="font-weight:500;color:rgba(34,34,34,0.8)" style="cursor:pointer">
                                            <ng-container *ngIf="album?.isSingleartist;">
                                                <span class="artist-name">

                                                    <sd-follow
                                                        [data]="{'from':'song-detail','slug':mainArtist?.slug,'isFollowing':mainArtist?.isFollowing ,'version':2}">
                                                    </sd-follow>
                                                </span>
                                            </ng-container>
                                            <ng-container *ngIf="album?.isVariousArtists;">
                                                <sd-follow
                                                    [data]="{'from':'song-detail','slug':mainArtist?.multislug,'isFollowing':mainArtist?.isFollowing,'version':2, multiFollow: true}">
                                                </sd-follow>
                                            </ng-container>
                                        </span>
                                    </span>
                                </ng-container>
                            </div>
                        </div>
                    </ng-template>

              
                </div>
            </div>

            <!-----------Abhay Dynamic Data Code Ends from here ------------>


            <div class='flex-c-c  iccons mt-3'>
                <ng-container *ngIf="!(data.type == 'song-review-card' || data.type == 'album-review-card')">

                    <!-- <a (click)="global.trackEvent('Share', 'Instagram', type + ' - ' + shareUrl)"
                        class='' (click)="share()"
                        [href]="'https://www.facebook.com/sharer/sharer.php?u='+shareUrl | safe: 'url'" target="_blank">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 7C9.20435 7 8.44129 7.31607 7.87868 7.87868C7.31607 8.44129 7 9.20435 7 10C7 10.7956 7.31607 11.5587 7.87868 12.1213C8.44129 12.6839 9.20435 13 10 13C10.7956 13 11.5587 12.6839 12.1213 12.1213C12.6839 11.5587 13 10.7956 13 10C13 9.20435 12.6839 8.44129 12.1213 7.87868C11.5587 7.31607 10.7956 7 10 7ZM10 5C11.3261 5 12.5979 5.52678 13.5355 6.46447C14.4732 7.40215 15 8.67392 15 10C15 11.3261 14.4732 12.5979 13.5355 13.5355C12.5979 14.4732 11.3261 15 10 15C8.67392 15 7.40215 14.4732 6.46447 13.5355C5.52678 12.5979 5 11.3261 5 10C5 8.67392 5.52678 7.40215 6.46447 6.46447C7.40215 5.52678 8.67392 5 10 5ZM16.5 4.75C16.5 5.08152 16.3683 5.39946 16.1339 5.63388C15.8995 5.8683 15.5815 6 15.25 6C14.9185 6 14.6005 5.8683 14.3661 5.63388C14.1317 5.39946 14 5.08152 14 4.75C14 4.41848 14.1317 4.10054 14.3661 3.86612C14.6005 3.6317 14.9185 3.5 15.25 3.5C15.5815 3.5 15.8995 3.6317 16.1339 3.86612C16.3683 4.10054 16.5 4.41848 16.5 4.75ZM10 2C7.526 2 7.122 2.007 5.971 2.058C5.187 2.095 4.661 2.2 4.173 2.39C3.739 2.558 3.426 2.759 3.093 3.093C2.78001 3.3954 2.53935 3.76458 2.389 4.173C2.199 4.663 2.094 5.188 2.058 5.971C2.006 7.075 2 7.461 2 10C2 12.474 2.007 12.878 2.058 14.029C2.095 14.812 2.2 15.339 2.389 15.826C2.559 16.261 2.759 16.574 3.091 16.906C3.428 17.242 3.741 17.443 4.171 17.609C4.665 17.8 5.191 17.906 5.971 17.942C7.075 17.994 7.461 18 10 18C12.474 18 12.878 17.993 14.029 17.942C14.811 17.905 15.338 17.8 15.826 17.611C16.259 17.442 16.574 17.241 16.906 16.909C17.243 16.572 17.444 16.259 17.61 15.829C17.8 15.336 17.906 14.809 17.942 14.029C17.994 12.925 18 12.539 18 10C18 7.526 17.993 7.122 17.942 5.971C17.905 5.189 17.8 4.661 17.61 4.173C17.4593 3.765 17.2191 3.39596 16.907 3.093C16.6047 2.77985 16.2355 2.53917 15.827 2.389C15.337 2.199 14.811 2.094 14.029 2.058C12.925 2.006 12.539 2 10 2ZM10 0C12.717 0 13.056 0.00999994 14.122 0.0599999C15.187 0.11 15.912 0.277 16.55 0.525C17.21 0.779 17.766 1.123 18.322 1.678C18.8305 2.1779 19.224 2.78259 19.475 3.45C19.722 4.087 19.89 4.813 19.94 5.878C19.987 6.944 20 7.283 20 10C20 12.717 19.99 13.056 19.94 14.122C19.89 15.187 19.722 15.912 19.475 16.55C19.2247 17.2178 18.8311 17.8226 18.322 18.322C17.822 18.8303 17.2173 19.2238 16.55 19.475C15.913 19.722 15.187 19.89 14.122 19.94C13.056 19.987 12.717 20 10 20C7.283 20 6.944 19.99 5.878 19.94C4.813 19.89 4.088 19.722 3.45 19.475C2.78233 19.2245 2.17753 18.8309 1.678 18.322C1.16941 17.8222 0.775931 17.2175 0.525 16.55C0.277 15.913 0.11 15.187 0.0599999 14.122C0.0129999 13.056 0 12.717 0 10C0 7.283 0.00999994 6.944 0.0599999 5.878C0.11 4.812 0.277 4.088 0.525 3.45C0.775236 2.78218 1.1688 2.17732 1.678 1.678C2.17767 1.16923 2.78243 0.775729 3.45 0.525C4.088 0.277 4.812 0.11 5.878 0.0599999C6.944 0.0129999 7.283 0 10 0Z"
                                fill="#222222" />
                        </svg>

                    </a> -->

                    <a (click)="global.trackEvent('Share', 'Facebook', type + ' - ' + shareUrl)" class=''
                        (click)="share()"
                        [href]="'https://www.facebook.com/sharer/sharer.php?u='+shareUrl | safe: 'url'" target="_blank">
                        <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7 11.5H9.5L10.5 7.5H7V5.5C7 4.47 7 3.5 9 3.5H10.5V0.14C10.174 0.0970001 8.943 0 7.643 0C4.928 0 3 1.657 3 4.7V7.5H0V11.5H3V20H7V11.5Z"
                                fill="#222222" />
                        </svg>
                    </a>




                    <a *ngIf="data.type == 'song-review-card' || data.type == 'album-review-card'" class=' m-l-20 '
                        (click)="global.trackEvent('Share', 'Download', type + ' - ' + shareUrl); global.saveFile(imageToShow, 'Review Card');">
                        <img src="../../assets/icons/fi_download.svg">

                    </a>

                </ng-container>

                <ng-container *ngIf="data.type == 'song-review-card' || data.type == 'album-review-card'">
                    <a (click)="global.trackEvent('Share', 'Facebook', type + ' - ' + shareUrl); downloadCard('fb_card', 'Facebook Review Card');"
                        class=''>
                        <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7 11.5H9.5L10.5 7.5H7V5.5C7 4.47 7 3.5 9 3.5H10.5V0.14C10.174 0.0970001 8.943 0 7.643 0C4.928 0 3 1.657 3 4.7V7.5H0V11.5H3V20H7V11.5Z"
                                fill="#222222" />
                        </svg>
                    </a>
                    <!-- <a (click)="global.trackEvent('Share', 'Twitter', type + ' - ' + shareUrl); downloadCard('fb_card', 'Twitter Review Card');"
                        class='btn btn-rounded btn-icon btn-twitter m-l-10'>
                        <i class='fa fa-twitter white'></i>
                    </a> -->
                    <a *ngIf="data.type == 'song-review-card' || data.type == 'album-review-card'" class=' m-l-20  '
                        (click)="global.trackEvent('Share', 'Download', type + ' - ' + shareUrl); downloadCard('insta_card', 'Instagram Review Card');">
                        <img src="../../assets/icons/fi_download.svg">
                    </a>
                    <!-- <a *ngIf="global.isMobile()"
                        (click)="global.trackEvent('Share', 'Whatsapp', type + ' - ' + shareUrl)"
                        class='btn btn-rounded btn-icon btn-success m-l-10'
                        [href]="'whatsapp://send?text='+shareText + ' ' + shareUrl | safe: 'url'">
                        <i class='fa fa-whatsapp'></i>
                    </a> -->
                </ng-container>
            </div>

            <div class="input-group m-t-20" *ngIf="data.type != 'song-review-card' && data.type != 'album-review-card'">
                <div class="input-group-prepend">
                    <span class="input-group-text"
                        (click)="global.copyInputMessage(url); global.trackEvent('Share', 'Share-Copy', type + ' - ' + shareUrl);"><svg
                            width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20 9H11C9.89543 9 9 9.89543 9 11V20C9 21.1046 9.89543 22 11 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9Z"
                                stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5"
                                stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg></span>
                </div>
                <input #url class='block form-control p-5 ' [value]="shareUrl">
            </div>

            <!-- <input #url class='d-none form-control p-5 m-t-20' [value]="shareUrl"
                [class.hidden]="(data.type == 'song-review-card' || data.type == 'album-review-card') && !data.customData.previewCampaign">  -->

            <div class='flex-c-c'
                [class.hidden]="(data.type == 'song-review-card' || data.type == 'album-review-card')">
                <button class='button pointer m-t-20'
                    (click)="clipboard.copy(shareUrl);toastrService.success('Copied successfully'); global.trackEvent('Share', 'Share-Copy', type + ' - ' + shareUrl);">
                    Copy Link</button>
            </div>
        </div>

        <div id="embed" class='tab-pane'
            *ngIf="data.type == 'song' || data.type == 'album' || data.type == 'playlist' || data.type == 'video'">
            <textarea #embed class='block form-control-text p-15 t-l'
                style="height: 125px">&lt;iframe width="100%" height="{{iframeHeight}}" scrolling="no" frameborder="no" src="{{global.basePrefix}}/{{type}}-embed/{{data.slug}}"&gt;&lt;/iframe&gt;</textarea>

            <ng-container *ngIf="data.type == 'song' || data.type == 'album' || data.type == 'playlist'">
                <section class=" m-t-20" *ngIf="albumLoaded; else albumLoading">
                    <div class='flex-sb-un p-10 rounded-5'>
                        <a id="albumArt" class="" href="/{{detailPrefix}}/{{album.slug}}" target="_blank">
                            <div class=" bgImageFull" [style.background-image]="'url(' + album.image + ')'"
                                alt="Album Art"></div>

                        </a>
                        <div id="albumDetails" class="w-100p-m150  p-l-20">
                            <div class='w-full p-t-5 f11'>
                                <div id="albumhead" style="text-transform:uppercase" class=" p-b-2">{{(this.type ==
                                    'song' || this.type == '')?
                                    "Single": type}}</div>
                                <a href="/{{detailPrefix}}/{{album.slug}}" target="_blank"
                                    class="album-name text-capitalize text-black f22 text-ellipsis p-b-4">{{album.title}}</a>
                                <a *ngIf="!album.isVariousArtists" href="/{{mainArtist.slug}}" target="_blank"
                                    class="f14 text-capitalize text-ellipsis ">{{mainArtist.name}}</a>
                                <a *ngIf="album.isVariousArtists" class='f16 text-capitalize text-ellipsis'>Various
                                    Artists</a>

                            </div>
                        
                        </div>
                    </div>
                    <ul class="p-0 m-0" style="max-height: 141px; overflow: auto;font-family: 'Poppins' !important;"
                        *ngIf="type=='album' || type=='playlist'">
                        <ng-container *ngFor="let song of album.tracks; let i=index;">
                            <song-widget-v2 class="songWidget songInlineWidget p-5"
                                [data]="{'for':'embed','tracks':album.tracks,'type':'','widget':'inline','itemNum':i,'skeletonLoading':false, 'image':(type=='playlist')?true:false, 'moreOptions':true, 'detailPageTracks': true, 'widget2': 'a'}">
                            </song-widget-v2>
                        </ng-container>
                    </ul>
                    <!-- <div class='flex-fe-c bg-white h-20 light-border-top'>
                        <img class='h-full'
                            lazyLoad="https://songdewnetwork.com/sgmedia/assets/images/songdew-logo.png">
                    </div> -->
                </section>
                <ng-template #albumLoading>
                    <section class="bg-white border m-t-20">
                        <div class="bg-white p-20 border">
                            <div class="skeletonLoading w-full h-150"></div>
                        </div>
                    </section>
                </ng-template>
            </ng-container>

            <ng-container *ngIf="data.type == 'video'">
                <section class="bg-white border m-t-20" *ngIf="mainVideoLoaded; else mainVideoLoading">
                    <!-- video player -->
                    <div class='embedVideo'>
                        <div id='mainVideoElemEmbed'></div>
                    </div>
                    <!-- / video player -->

                    <div class="p-10 flex-sb-c">
                        <div>
                            <a href="/{{global.videoDetailPrefix}}/{{mainVideo.slug}}" target="_blank"
                                class='text-capitalize text-ellipsis strong'>{{mainVideo.title}}</a>
                            <a href="/{{mainVideo.artistSlug}}" target="_blank"
                                class="text-ellipsis">{{mainVideo.artist}}</a>
                        </div>

                        <a class="flex-sb-c pointer" href="/{{global.videoDetailPrefix}}/{{mainVideo.slug}}"
                            target="_blank">
                            <i class='icon-share m-r-5'></i>
                            <span>Share</span>
                        </a>
                    </div>
                </section>
                <ng-template #mainVideoLoading>
                    <div class="bg-white p-20 border m-t-20">
                        <div class="skeletonLoading w-full h-150"></div>
                    </div>
                </ng-template>
            </ng-container>

            <div class='flex-c-c m-t-40'>
                <button class=' button'
                    (click)="global.copyInputMessage(embed); global.trackEvent('Share', 'Embed-Copy', type + ' - ' + shareUrl);">
                    Copy Embded Code</button>
            </div>
        </div>
    </div>
</div>
